import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons";
import { renderDataCellLots } from "./RenderDataColumnsLots";
import { renderFilterCellLots } from "./RenderFilterColumnsLots";
import { renderHeaderCell } from "./RenderHeaderColumn";
import { renderFilterCellDocs } from "./RenderFilterColumnsDocs";
import { renderDataCellDocs } from "./RenderDataColumnsDocs";
import { renderDataCellDocsAdm } from "../UtilsAdmin/AdmRenderDataColumnsDocs";
import "../Dashboard/Default/TabLots/LotsTable.css";
import { renderDataCellLotsAdm } from "../UtilsAdmin/AdmRenderDataColumnsLots";
import { renderFilterCellLotsAdm } from "../UtilsAdmin/AdmRenderFilterColumnsLots";
import { renderFilterCellDocsAdm } from "../UtilsAdmin/AdmRenderFilterColumnDocs";
import React from "react";

// Fonction qui renvoie la ligne de nommage des colonnes
export const renderHeaderRow = (
  config,
  colorFilter,
  toggleDateFilterVisibility,
  t
) => (
  <tr className="style_thead_tr">
    {config.map((col, idx) => (
      // Cellule d'en-tête unique
      <React.Fragment key={`head-${idx}-${col.key || col.dataKey || "col"}`}>
        {renderHeaderCell(col, idx, colorFilter, toggleDateFilterVisibility, t)}
      </React.Fragment>
    ))}
  </tr>
);

// Fonction qui renvoie la ligne des filtres/tri
export const renderFilterRow = (config, context) => {
  if (context.tableId === "Lots") {
    return (
      <tr className="style_tbody_tr_first">
        {config.map((col, idx) => (
          // Cellule de filtre unique pour éviter les doublons
          <React.Fragment key={`filter-lots-${idx}-${col.key || col.dataKey || "col"}`}>
            {col.admFilterType
              ? renderFilterCellLotsAdm(col, idx, context)
              : renderFilterCellLots(col, idx, context)}
          </React.Fragment>
        ))}
      </tr>
    );
  } else if (context.tableId === "Docs") {
    return (
      <tr className="style_tbody_tr_first">
        {config.map((col, idx) => (
          <React.Fragment key={`filter-docs-${idx}-${col.key || col.dataKey || "col"}`}>
            {col.admFilterType
              ? renderFilterCellDocsAdm(col, idx, context)
              : renderFilterCellDocs(col, idx, context)}
          </React.Fragment>
        ))}
      </tr>
    );
  }
};

// Fonction qui renvoie les lignes de data
export const renderDataRow = (item, config, context, index) => {
  const key = item.kInstanceId ?? `fallback-key-${index}`;

  if (context.tableId === "Lots") {
    return (
      // Ligne de données pour les Lots uniques
      <tr key={`row-lots-${key}`} className="style_tbody_tr_second">
        {config.map((col, idx) => (
          // Cellule de données unique
          <React.Fragment key={`data-lots-${idx}-${col.key || col.dataKey || "col"}`}>
            {col.admData
              ? renderDataCellLotsAdm(item, col, context, idx)
              : renderDataCellLots(item, col, context, idx)}
          </React.Fragment>
        ))}
      </tr>
    );
  }

  if (context.tableId === "Docs") {
    return (
      <tr key={`row-docs-${key}`} className="style_tbody_tr_second">
        {config.map((col, idx) => (
          <React.Fragment key={`data-docs-${idx}-${col.key || col.dataKey || "col"}`}>
            {col.admData
              ? renderDataCellDocsAdm(item, col, context, idx)
              : renderDataCellDocs(item, col, context, idx)}
          </React.Fragment>
        ))}
      </tr>
    );
  }

  return null;
};

// Colonne de tri
export const renderSortableColumn = (context, columnKey, field) => {
  const { colorFilterAction, sortField, sortOrder, handleSort } = context;

  return (
    <th
      style={{ backgroundColor: colorFilterAction }}
      className="style_tbody_th style_sort"
      key={`sortable-${field}`}
      onClick={() => handleSort(field)}
    >
      {sortField === field && sortOrder === "asc" ? (
        <FontAwesomeIcon icon={faSortDown} />
      ) : (
        <FontAwesomeIcon icon={faSortUp} />
      )}
    </th>
  );
};

// Colonne input
export const renderSetFilterInputColumn = (
  context,
  columnKey,
  colspanValue,
  placeholderValue,
  valueData
) => {
  const { colorFilterAction, t, setFilter, filter } = context;

  const shouldUseStorage = context.tableId === "Lots";
  const localStorageKey = `filter_${valueData}`;
  const localStorageValue = shouldUseStorage
    ? localStorage.getItem(localStorageKey)
    : "";
  const inputValue = filter[valueData] ?? localStorageValue ?? "";

  const handleChange = (e) => {
    const value = e.target.value;
    setFilter({ ...filter, [valueData]: value });
    if (shouldUseStorage) {
      localStorage.setItem(localStorageKey, value);
    }
  };

  return (
    <th
      className="style_tbody_th input_size"
      style={{ backgroundColor: colorFilterAction }}
      colSpan={colspanValue}
    >
      <input
        type="text"
        className="form-control placeholder-font style_input"
        placeholder={t(placeholderValue)}
        value={inputValue}
        onChange={handleChange}
      />
    </th>
  );
};

// Colonne select
export const renderSetFilterSelectColumn = (
  context,
  columnKey,
  valueData,
  valueFilterData,
  placeholderValue
) => {
  const { colorFilterAction, setFilter, filter, t } = context;

  let options = Array.isArray(valueData) ? valueData.flat() : [];

  if (typeof options[0] === "object" && options[0] !== null) {
    options = options.map(
      (item) =>
        item.id ?? item.ModelDocumentStatus ?? item.ModelInstanceStatus ?? "-"
    );
  }

  let uniqueOptions = [...new Set(options.filter(Boolean))];

  const shouldUseStorage = context.tableId === "Lots";
  const localStorageKey = `filter_${valueFilterData}`;
  const localStorageValue = shouldUseStorage
    ? localStorage.getItem(localStorageKey)
    : "";
  const selectValue = filter[valueFilterData] ?? localStorageValue ?? "";

  // Ensure the currently selected value is present in the options
  if (selectValue && !uniqueOptions.includes(selectValue)) {
    uniqueOptions = [selectValue, ...uniqueOptions];
  }

  const handleChange = (e) => {
    const value = e.target.value;
    setFilter({ ...filter, [valueFilterData]: value });
    if (shouldUseStorage) {
      localStorage.setItem(localStorageKey, value);
    }
  };

  return (
    <th
      className="style_tbody_th"
      style={{ backgroundColor: colorFilterAction }}
    >
      <select
        className="form-select style_select"
        onChange={handleChange}
        value={selectValue}
      >
        <option value="">{t(placeholderValue)}</option>
        {uniqueOptions.map((result, idx) => (
          <option
            value={result}
            // Clé unique pour chaque option
            key={`opt-${columnKey}-${idx}-${String(result)}`}
          >
            {result}
          </option>
        ))}
      </select>
    </th>
  );
};
